import { render, staticRenderFns } from "./page-create-email-push.vue?vue&type=template&id=15317c5c"
import script from "./page-create-email-push.vue?vue&type=script&lang=ts"
export * from "./page-create-email-push.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports